export default {
      id: "i-main-advantages-01-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "img/sprite.svg#i-main-advantages-01",
      toString: function () {
        return this.url;
      }
    }